module.exports = __webpack_public_path__ + "img/footer-left-ctas.54d18088.png";